import React, { useEffect } from 'react'
import { graphql, Link } from 'gatsby'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import NewsletterForm from 'components/newsletterForm'
import LayoutContent from 'components/layouts/layoutContent'
import AuthorArticle from 'components/blog/authorArticle'
import Button from 'components/button'
import { useGlobalState } from 'utils/hooks/globalStateProvider'
import { COMMON, LINK } from 'utils/intl/common.js'
import { impContent, impContentSummary } from 'utils'

function CaseStudy(props) {
  const { data } = props
  const dataFooter = data.footer.data
  const dataHeader = data.header.data
  const dataPage = data.page.data
  const breakpoints = useBreakpoint()
  const [, dispatch] = useGlobalState()

  useEffect(() => {
    if (breakpoints.md) {
      const body = document.querySelector('body')
      const wrapper = document.querySelector('.tl-edges')

      body.style.overflow = 'initial'
      wrapper.style.overflow = 'initial'

      return () => {
        body.style.removeProperty('overflow')
        wrapper.style.removeProperty('overflow')
      }
    }
  })

  return (
    <LayoutContent
      data={dataPage}
      dataFooter={dataFooter}
      dataHeader={dataHeader}
      breadcrumbisDark
      breadcrumbHasBorder
      breadcrumbLinks={[{ title: 'Case studies', link: 'case-studies' }]}
    >
      <div className="hero-small hero--cs">
        <div className="container">
          <div className="row">
            <div className="f--tablet f-align-items-center col col-md-10 col--center">
              <div className="hero__title mt-5 mt-md-0">
                <h1 className="c-white mb-3">{dataPage.title.text}</h1>
                <p className="c-white mb-0">{dataPage.description.text}</p>
              </div>
              <div className="hero__image mt-4 mt-md-0">
                <img
                  loading="lazy"
                  src={dataPage.author.document.data.picture.url}
                  alt={dataPage.author.document.data.name.text}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="article__container mt-4 mt-md-0">
        <div className="container">
          <div className="row">
            <div className="f--desktop col col-md-10 col-lg-7 col--center">
              <div className="article__sidebar article__sidebar--cs">
                <div className="article__sidebar__author">
                  {dataPage.company.document && (
                    <div className="f f-direction-column">
                      <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-3">{COMMON.COMPANY}</span>
                      <a
                        className="f f-direction-column mb-1 mb-lg-0"
                        href={dataPage.company.document.data.website.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          loading="lazy"
                          className="img-circle img-circle--big mb-2"
                          src={dataPage.company.document.data.logo.url}
                          alt={dataPage.company.document.data.name.text}
                        />
                        <h4 className="h5 link c-brand-500 ft-600 c-text-black-lighter mb-1">
                          {dataPage.company.document.data.name.text}
                        </h4>
                      </a>
                      <p className="ft-tertiary c-text-black-light mb-2">
                        {dataPage.company.document.data.description.text}
                      </p>
                      <hr className="mb-2" />
                      {dataPage.company.document.data.headquarters.text && (
                        <div>
                          <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">
                            {COMMON.HEADQUARTERS}
                          </span>
                          <p className="ft-tertiary c-text-black-light">
                            {dataPage.company.document.data.headquarters.text}
                          </p>
                        </div>
                      )}
                      {dataPage.company.document.data.headquarters.text && <hr className="mb-2" />}
                      {dataPage.company.document.data.founded.text && (
                        <div>
                          <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">
                            {COMMON.FOUNDED}
                          </span>
                          <p className="ft-tertiary c-text-black-light">
                            {dataPage.company.document.data.founded.text}
                          </p>
                        </div>
                      )}
                      {dataPage.company.document.data.founded.text && <hr className="mb-2" />}
                      {dataPage.company.document.data.company_size.text && (
                        <div>
                          <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">
                            {COMMON.COMPANY_SIZE}
                          </span>
                          <p className="ft-tertiary c-text-black-light">
                            {dataPage.company.document.data.company_size.text}
                          </p>
                        </div>
                      )}
                      {dataPage.company.document.data.company_size.text && <hr className="mb-2" />}
                      {dataPage.company.document.data.key_challenges.text && (
                        <div>
                          <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">
                            {COMMON.KEY_CHALLENGES}
                          </span>
                          <p className="ft-tertiary c-text-black-light">
                            {dataPage.company.document.data.key_challenges.text}
                          </p>
                        </div>
                      )}
                      {dataPage.company.document.data.key_challenges.text && <hr className="mb-2" />}
                      {dataPage.company.document.data.solutions.text && (
                        <div>
                          <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">
                            {COMMON.SOLUTIONS}
                          </span>
                          <p className="ft-tertiary c-text-black-light">
                            {dataPage.company.document.data.solutions.text}
                          </p>
                        </div>
                      )}
                      {dataPage.company.document.data.solutions.text && <hr className="mb-2" />}
                      {dataPage.company.document.data.key_results.text && (
                        <div>
                          <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-1">
                            {COMMON.KEY_RESULTS}
                          </span>
                          <p className="ft-tertiary c-text-black-light mb-0">
                            {dataPage.company.document.data.key_results.text}
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="article__sidebar__summary">
                  <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-2">{COMMON.SUMMARY}</span>
                  {impContentSummary(dataPage.content.raw)}
                </div>
              </div>
              <div className="article__content article__content--negative">
                <div>{impContent(dataPage.content.raw, dispatch)}</div>
              </div>
              <div className="article__started article__started--cs mt-4">
                <div>
                  <img className="mb-1" loading="lazy" src="../../../images/logo-black.svg" alt="Qovery white logo" />
                  <h4 className="ft-600 c-text-black-lighter mb-1">{COMMON.TITLE_STARTED}</h4>
                  <p className="ft-tertiary c-text-black-lightest mb-2">
                    Qovery is a{' '}
                    <Link title="DevOps Automation Platform" className="link c-brand-500" to="/">
                      DevOps Automation Platform
                    </Link>{' '}
                    Helping 200+ Organizations To Ship Faster and Eliminate DevOps Hiring Needs,
                  </p>
                  <Button className="btn btn--medium btn--full f-jc-space-c" url={LINK.QOVERY_CONSOLE}>
                    {COMMON.DEPLOY_MY_APPS}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="article__bottom">
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-6 col--center">
              <NewsletterForm />
              {dataPage.company.document && (
                <AuthorArticle title={COMMON.COMPANY} slug={`blog`} data={dataPage.company.document.data} />
              )}
            </div>
          </div>
        </div>
      </div>
    </LayoutContent>
  )
}

export const queryCaseStudy = graphql`
  query ($uid: String) {
    header: prismicHeader {
      ...prismicHeaderFragment
    }
    page: prismicCasestudy(uid: { eq: $uid }) {
      ...prismicCasestudyFragment
    }
    footer: prismicFooter {
      ...prismicFooterFragment
    }
  }
`

export default CaseStudy
